import React from 'react';

export const InfoIcon = React.forwardRef((_, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    ref={ref}
  >
    <path
      d="M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.419 0-8-3.582-8-8S3.58 0 8 0zm0 1C4.133 1 1 4.134 1 8s3.134 7 7 7c3.865 0 7-3.134 7-7s-3.135-7-7-7zm.658 5.193v4.737c0 .927.067 1 .841 1.11v.46h-3v-.46c.736-.11.828-.168.828-1.11V8.18c0-.884-.066-.913-.741-1.03v-.438c.728-.102 1.45-.277 2.072-.518zM7.91 3.5c.45 0 .788.387.788.898 0 .46-.338.868-.801.868-.417 0-.795-.408-.795-.868 0-.511.378-.898.808-.898z"
      opacity=".7"
    />
  </svg>
));

export const InfoGhostIcon = React.forwardRef(
  (_, ref: React.Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      ref={ref}
    >
      <path d="M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm.658 6.194c-.669.25-1.364.424-2.072.518v.438c.675.117.741.146.741 1.03v2.899c-.012.8-.133.857-.828.961v.46h3v-.46c-.774-.11-.841-.183-.841-1.11zM7.91 3.5c-.43 0-.808.387-.808.898 0 .46.378.868.795.868.463 0 .801-.408.801-.868 0-.511-.338-.898-.788-.898z" />
    </svg>
  ),
);
